// ============================================
// SEO metadata per page - Slovenian
// ============================================
export const seoMeta = {
  '/sl/': {
    title: 'Agencija za SEO & partnerski marketing | go2digital',
    description: 'Generiramo organski promet in monetiziramo z dokazanimi affiliate sistemi. Gradimo visoko zmogljiva digitalna sredstva, ne le kampanje.',
  },
  '/sl/o-nas/': {
    title: 'O nas - Graditelji platform, ne klasična agencija | go2digital',
    description: 'go2digital gradi, upravlja in vodi digitalne platforme. Odkrijte, kako smo iz bloga prerasli v ekosistem 5 aktivnih platform na 3 trgih.',
  },
  '/sl/storitve/': {
    title: 'Storitve - SEO, affiliate, razvoj platform & AI | go2digital',
    description: 'Štiri povezane discipline: SEO & organska rast, affiliate monetizacija, razvoj platform in integracija AI. Preizkušeno na naših lastnih platformah.',
  },
  '/sl/projekti/': {
    title: 'Naše platforme - Dokaz izvedbe | go2digital',
    description: 'Odkrijte digitalne platforme, ki smo jih zgradili, jih imamo v lasti in upravljamo. 500K+ mesečnih obiskov, 5 aktivnih platform, 3 trgi.',
  },
};
